var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1.6 2L12 11.7 4.6 6h14.8zm1.1 12h-17c-.3 0-.5-.2-.5-.5V7.3l8.4 6.5c.2.1.4.2.6.2s.4-.1.6-.2L21 7.3v10.2c0 .3-.2.5-.5.5z"}));
}

Mail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Mail;

Mail.default = Mail;
